<template>
  <div v-if="data && data.length" class="product-additional-options">
    <div v-for="(option, index) in addons" :key="index" class="product-additional-option"
      :class="{ 'is-checked': isAddonSelected(option) }">
      <product-addon v-model="model" :option="option" @change="$emit('change')" />
      <div class="pro-guard-description fix-margin">
        <!-- {{ option.description }} -->
        <p v-html="$t('perfectFit.perfectFitDescription1')" />
      </div>
      <span class="option-open-modal fix-margin" @click.prevent="openModal(option)">
        {{ $t("actions.showMore") }} <b-icon icon="arrow-right-bold" />
      </span>
    </div>
    <div v-if="proGuard.length" class="product-additional-option" :class="{ 'is-checked': proGuardSelected }">
      <product-addon v-for="(item, index) in proGuard" :key="index" v-model="model" :option="item" :addons="proGuard"
        @change="$emit('change')" />
      <div class="pro-guard-description fix-margin">
        {{ $t('perfectFit.proGuardDescription') }}
      </div>
      <span class="option-open-modal fix-margin" @click.prevent="openModal(proGuard[0])">
        {{ $t("actions.showMore") }} <b-icon icon="arrow-right-bold" />
      </span>
    </div>
    <b-modal v-model="modal" :width="640" scroll="keep" @close="closeModal">


      <template v-if="addonMoreInfo === 'perfect-fit' && currentLang === 'de' && project === 'schuette'">
        <div class="addon-modal content">
          <h3>Schuette® PerfectFit</h3>
          <p><b>Sie haben sich bei den Maßen vertan oder spontan doch in eine andere Farbe verliebt? Kein Problem!</b>
            Schuette® PerfectFit ermöglicht Ihnen die nachträgliche 360° Produkt-Anpassung für ein wunschlos glückliches
            Gesamtbild.</p>
          <p>1x Maß-Korrektur, Halter- oder Farbwechsel inklusive, sogar bis zu 30 Tagen nach Lieferung!</p>
          <p>Mit diesem Sorglos-Glücklich-Paket haben Sie immer den Kopf frei und die absolute Sicherheit, dass Ihr
            Schuette® Qualitätsprodukt in jeder Hinsicht zu Ihnen, Ihrem Stil und Ihrem Zuhause passen wird, <b>auch
              wenn sich herausstellt, dass Ihnen während der Bestellung die Nachbars-Katze auf die Tastatur gesprungen
              ist!</b></p>
          <p>Das Rundum-Korrektur-Paket beinhaltet:</p>
          <ul>
            <li><b>Rundumschutz für JEDEN Korrektur-Wunsch</b>: Außer Maß-Anpassung <b>auch</b> Farb-, Kollektion- oder
              Halter-Korrektur möglich. <span class="bolded-green">Nur bei Schuette®!</span></li>
            <li><b>Jedes Produkt</b>: Plissees, Rollos, Vorhänge, ohne Einschränkungen. <span class="bolded-green">Nur
                bei Schuette®!</span></li>
            <li><b>Jeweils pro Produkt zubuchbar</b>: Muss nicht zur ganzen Bestellung hinzugefügt werden. Preis pro
              Produkt mit & ohne PerfectFit ersichtlich.</li>
            <li><b>Keine Mengenbegrenzung pro Bestellung</b>: PerfectFit kann zu jedem Produkt getrennt hinzugefügt
              werden.</li>
            <li><b>Kein Fix-Preis</b>: Je kleiner das Produkt-Maß, desto niedriger der Preis.</li>
            <li><b>Sogar bis zu 30 Tagen</b> nach Lieferung.</li>
            <li><b>Beliebiger Rücksendekarton</b>: Die Rücksendung von Ihnen zu uns muss nicht im Originalkarton
              erfolgen.</li>
            <li><b>Kostenloser Versand</b> nach Anpassung von uns zu Ihnen, ganz gleich welches Produkt-Maß.</li>
          </ul>
          <table>
            <thead>
              <th />
              <th>Schuette® PerfectFit</th>
            </thead>
            <tbody>
              <tr>
                <td>Andere Maße</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Andere Stoff-Farbe und -Kollektion</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Andere Halterung</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Jede Produktart möglich</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Zeit ab Lieferung (Tage)</td>
                <td><b>30</b></td>
              </tr>
              <tr>
                <td>Kostenloser Versand bei jedem Maß</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Optional & separat zubuchbar</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Jeweils pro Produkt zubuchbar</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
            </tbody>
          </table>
          <div class="addon-box">
            <p>So leicht geht's:</p>
            <ul>
              <li><b>Schritt 1</b>: Schuette® Kundenservice kontaktieren und neue Wunsch-Konfiguration nennen. (Wie
                immer erhalten Sie natürlich eine persönliche Beratung unserer Schuette® Experten.)</li>
              <li><b>Schritt 2</b>: Senden Sie uns daraufhin Ihr Schuette® Produkt zu.</li>
              <li><b>Schritt 3</b>: Wir stellen Ihr Schuette® PerfectFit-Produkt nach Ihren neuen Vorgaben her,
                verpacken es und schicken es mit einem Abschiedskuss zu Ihnen zurück.</li>
              <li><b>Schritt 4</b>: Voilà - Ihr erneut mit Liebe hergestelltes Schuette® PerfectFit-Produkt kommt jetzt
                in jeder Hinsicht perfekt passend bei Ihnen an.</li>
            </ul>
          </div>
          <div class="conditions">
            <p>Schuette® Perfect Fit Bedingungen und Konditionen:</p>
            <ol>
              <li>PerfectFit umfasst eine einmalige Anpassung oder Neuanfertigung von Ihrem Schuette® Produkt. Pro
                Produkt mit PerfectFit-Schutz können insgesamt ein Mal die Produkt-Maße, Farben und/oder Halter geändert
                werden, d.h. der Kunde kann im Rahmen von PerfectFit sein Schuette® Produkt einmalig vollständig neu
                konfigurieren.</li>
              <li>Wird ein Austausch des Produkts angefragt, weil der Fehler bei uns liegt, werden wir ihn
                selbstverständlich unabhängig von PerfectFit direkt beheben, wobei Ersatzlieferungen in der ursprünglich
                bestellten Konfiguration gefertigt werden. Hier kann bei Bedarf PerfectFit verwendet werden, um die
                Neuanfertigung in einer anderen Produkt-Konfiguration produzieren zu lassen.</li>
              <li>PerfectFit gilt für das Produkt, zu welchem es gebucht wurde.</li>
              <li>Um vom dazugebuchten PerfectFit-Schutz Gebrauch machen zu können, muss unser Kundenservice innerhalb
                von 30 Kalendertagen nach der Lieferung hierüber informiert werden. Eine Empfangnahme des
                Aktivierungswunsches ist gleich mit einer Rückmeldung von unserem Kundenservice. Nach erfolgreicher
                Kontaktaufnahme mit dem Support-Team können weitere Schritte in die Wege geleitet werden.</li>
              <li>Wenn die neuen Wunsch-Maße kleiner sind als die zu Beginn bestellten Maße, wird bestmöglich das
                ursprüngliche Produkt überarbeitet. Ist dies nicht möglich, wird ein vollständig neues Produkt
                angefertigt.</li>
              <li>Ist die neue Produkt-Konfiguration teurer, muss lediglich die Differenz von Ihnen beglichen werden.
                Ist die neue Produkt-Konfiguration günstiger, wird keine Erstattung der Differenz durchgeführt.
                Verglichen werden hierbei der Produkt-Preis zum Zeitpunkt der Bestellung sowie der Produkt-Preis zum
                Zeitpunkt der Aktivierung von PerfectFit.</li>
              <li>Die Kosten für den Rückversand sind vom Kunden zu tragen. Im Rahmen von PerfectFit übernehmen wir die
                Kosten für den erneuten Versand von uns an den Kunden.</li>
              <li>Eine Stornierung von Produkten nach Maß und Erstattung des Kaufpreises ist im Rahmen von Schuette®
                PerfectFit nicht möglich. Auch kann die Zusatzoption PerfectFit nicht storniert und bei Nichtgebrauch
                nicht ausgezahlt oder gegen einen Voucher eingelöst werden.</li>
              <li>PerfectFit kann bis zum Zeitpunkt der Lieferung der Schuette® Bestellung bei Bedarf nachträglich
                hinzugefügt werden.</li>
              <li>Es gelten keine Länder-Begrenzungen. Jedes Lieferland der Schuette® Manufaktur kann PerfectFit nutzen.
              </li>
            </ol>
          </div>
        </div>
      </template>
      <template v-if="addonMoreInfo === 'perfect-fit' && currentLang === 'en' && project === 'schuette'">
        <div class="addon-modal content">
          <h3>Schuette® PerfectFit</h3>
          <p>Schuette® PerfectFit allows you to make 360° product adjustments (size, fabric colour & mounting type) even
            up to 30 days after delivery!</p>
          <p>1x size correction, holder or colour change included, even up to 30 days after delivery!</p>
          <p>With this Carefree Happy Package, you can always rest assured that your Schuette® quality product will suit
            you, your style and your home in every way, <b>even if it turns out that the neighbour's cat jumped on your
              keyboard while you were ordering!</b></p>
          <p>The all-round correction package includes:</p>
          <ul>
            <li><b>All-round protection for ANY alteration request: in addition</b>: to size adjustments, colour,
              collection or bracket alterations are also possible. <span class="bolded-green">Only at Schuette®!</span>
            </li>
            <li><b>Any product</b>: Pleated blinds, roller blinds and curtains, no restrictions. <span
                class="bolded-green">Only at Schuette®!</span></li>
            <li><b>Can be added per product</b>: Does not need to be added to the whole order. Price shown per product
              with & without PerfectFit.</li>
            <li><b>No quantity limit per order</b>: PerfectFit can be added to each product individually.</li>
            <li><b>No fixed price</b>: The smaller the product size, the lower the price.</li>
            <li><b>Even up to 30 days</b> after delivery.</li>
            <li><b>Any return box</b>: The return from you to us does not have to be in the original box.</li>
            <li><b>Free shipping</b> regardless of product size after customisation from us to you.</li>
          </ul>
          <table>
            <thead>
              <th />
              <th>Schuette® PerfectFit</th>
            </thead>
            <tbody>
              <tr>
                <td>Other dimensions</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Different fabric color or collection</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Other bracket</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>All product types possible</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Time after delivery (days)</td>
                <td><b>30</b></td>
              </tr>
              <tr>
                <td>Free shipping with every order</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Optional & can be booked separately</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Can be booked per product</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
            </tbody>
          </table>
          <div class="addon-box">
            <p>It's that easy:</p>
            <ul>
              <li><b>Step 1</b>: Contact Schuette® customer service and state your new desired configuration. (As
                always, you will of course receive personalised advice from our Schuette® experts).'</li>
              <li><b>Step 2</b>: Then send us your Schuette® product.</li>
              <li><b>Step 3</b>: We manufacture your Schuette® PerfectFit product according to your new specifications,
                pack it and send it back to you with a kiss goodbye.</li>
              <li><b>Step 4</b>: Voilà - your Schuette® PerfectFit product, once again made with love, will now arrive
                at your home perfectly fitting in every way.</li>
            </ul>
          </div>
          <div class="conditions">
            <p>Schuette® PerfectFit Terms and Conditions:</p>
            <ol>
              <li>PerfectFit includes a one-time customisation or re-manufacturing of your Schuette® product. Product
                dimensions, colours and/or brackets can be changed once per product with PerfectFit protection, i.e. the
                customer can completely reconfigure their Schuette® product once as part of PerfectFit.</li>
              <li>If a product replacement is requested because the fault lies with us, we will of course rectify the
                fault directly, independently of PerfectFit, and the replacement deliveries will be made in the
                configuration originally ordered. If required, PerfectFit can be used to have the new product
                manufactured in a different product configuration.</li>
              <li>PerfectFit applies to the product for which it was booked.</li>
              <li>In order to take advantage of the PerfectFit protection you have purchased, you must contact Customer
                Services within 30 calendar days of delivery. Receipt of the activation request equates to a response
                from our Customer Service team. Once you have successfully contacted our customer service team, further
                steps can be taken.</li>
              <li>If the new required dimensions are smaller than those originally ordered, the original product will be
                reworked as far as possible. If this is not possible, a completely new product will be manufactured.
              </li>
              <li>If the new product configuration is more expensive, you will only have to pay the difference. If the
                new product configuration is cheaper, the difference will not be refunded. The product price at the time
                of ordering will be compared to the product price at the time of activating PerfectFit.</li>
              <li>The cost of return shipping is the responsibility of the customer. As part of PerfectFit, we will
                cover the cost of reshipment from us to the customer.</li>
              <li>Customised products cannot be cancelled and refunded under Schuette® PerfectFit. The additional
                PerfectFit option cannot be cancelled and cannot be refunded or exchanged for a voucher if not used.
              </li>
              <li>PerfectFit can be added at a later date up to the time of delivery of the Schuette® order if required
              </li>
              <li>There are no country restrictions. Any Schuette® manufacturing country can use PerfectFit.</li>
            </ol>
          </div>
        </div>
      </template>
      <template v-if="addonMoreInfo === 'perfect-fit' && currentLang === 'es' && project === 'schuette'">
        <div class=" addon-modal content">
          <h3>Schuette® PerfectFit</h3>

          <p>Schuette® PerfectFit le permite realizar ajustes 360° (dimensiones, color del tejido y tipo de instalación)
            después de la compra del producto ¡incluso hasta 30 días después de la entrega!</p>
          <p>1x corrección de tamaño, soporte o cambio de color incluido, ¡incluso hasta 30 días después de la entrega!
          </p>
          <p>Con este paquete siempre quedará satisfecho, teniendo la tranquilidad y la certeza absoluta de que su
            producto Schuette® se adaptará a usted, a su estilo y a su hogar en todos los aspectos, <b>¡incluso si
              resulta
              que el gato del vecino saltó sobre su teclado mientras estaba haciendo el pedido!</b></p>

          <p>El paquete de corrección integral incluye:</p>
          <ul>
            <li><b>Protección integral para CADA solicitud de corrección</b>: Además del ajuste del tamaño, también es
              posible la corrección de color y el cambio de soportes. <span class="bolded-green">¡Sólo con
                Schuette®!</span></li>
            <li><b>Todos los productos</b>: Estores plisados, estores enrollables y cortinas, sin restricciones. <span
                class="bolded-green">¡Sólo en Schuette®!</span></li>
            <li><b>Se pueden añadir productos individualmente</b>: No es necesario añadir todo el pedido. El precio es
              por
              producto con y sin PerfectFit.</li>
            <li><b>Sin límite de cantidad por pedido</b>: el servicio PerfectFit puede añadirse por separado a cada
              producto.</li>
            <li><b>Sin precio fijo</b>: cuanto menor sea el tamaño del producto, menor será el precio. Incluso hasta 30
              días después de la entrega.</li>
            <li><b>Cualquier caja de devolución</b> La devolución por su parte hacia nosotros no tiene que ser en la
              caja
              original.</li>
            <li><b>Envío gratuito</b>: tras la personalización, independientemente del tamaño del producto.</li>
          </ul>

          <table>
            <thead>
              <th></th>
              <th>Schuette® PerfectFit</th>
            </thead>
            <tbody>
              <tr>
                <td>Otras dimensiones</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Otro color de tejido y colección</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Otro soporte</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Cualquier tipo de producto</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Plazo de entrega (días)</td>
                <td><b>30</b></td>
              </tr>
              <tr>
                <td>Envío gratuito con todos los pedidos</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Opcional y se puede reservar por separado</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Puede realizarse por producto</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
            </tbody>
          </table>

          <div class="addon-box">
            <p>Así de fácil:</p>
            <ul>
              <li><b>Paso 1</b>: Póngase en contacto con el servicio de atención al cliente de Schuette® e indique la
                nueva configuración que desea. (Como siempre, recibirá el asesoramiento personalizado de nuestros
                expertos
                de Schuette®).</li>
              <li><b>Paso 2</b>: A continuación, envíenos su producto Schuette®</li>
              <li><b>Paso 3</b>: Fabricamos su producto Schuette® PerfectFit según sus nuevas especificaciones, lo
                embalamos y se lo enviamos de vuelta con un beso de despedida.</li>
              <li><b>Paso 4</b>: Voilà - su producto Schuette® PerfectFit, una vez más fabricado con amor, llega ahora
                perfectamente ajustado en todos los aspectos.</li>
            </ul>
          </div>

          <div class="conditions">
            <p>Términos y condiciones de Schuette® Perfect Fit:</p>
            <ol>
              <li>PerfectFit incluye una única personalización o nueva configuración de su producto Schuette®. Las
                dimensiones del producto, los colores y/o los soportes se pueden cambiar una vez por producto con la
                protección PerfectFit, es decir, el cliente puede reconfigurar completamente su producto Schuette® una
                vez
                como parte del paquete PerfectFit.</li>
              <li>Si se solicita un cambio del producto debido a un fallo nuestro, por supuesto lo subsanaremos
                directamente independientemente del PerfectFit, fabricándose así los productos de sustitución con la
                configuración pedida originalmente. Si es necesario, se puede utilizar el PerfectFit para reconfigurar
                este producto de forma diferente.</li>
              <li>PerfectFit se aplica al producto para el que se reservó.</li>
              <li>Para poder hacer uso de la protección PerfectFit, deberá informarse a nuestro servicio de atención al
                cliente en un plazo de 30 días naturales a partir de la entrega. La recepción de la solicitud de
                activación deberá ser confirmada por parte de nuestro servicio de atención al cliente. Una vez que se
                haya
                contactado con éxito con el equipo de asistencia, se podrán iniciar los pasos siguientes.</li>
              <li>Si las nuevas dimensiones solicitadas son inferiores a las dimensiones pedidas al principio, se
                adaptará
                el producto original en la medida de lo posible. Si no es posible, se fabricará un producto
                completamente
                nuevo.</li>
              <li>Si la nueva configuración del producto es más cara, sólo tendrá que pagar la diferencia. Si la nueva
                configuración del producto es más barata, no se reembolsará la diferencia. Se comparará el precio del
                producto en el momento del pedido y el precio del producto en el momento de la activación de PerfectFit.
              </li>
              <li>Los gastos de devolución correrán a cargo del cliente. En cambio, como parte de PerfectFit, correremos
                con los gastos del reenvío al cliente.</li>
              <li>La anulación de los productos personalizados y el reembolso del precio de compra no son posibles en el
                marco de Schuette® PerfectFit. En paquete PerfectFit tampoco se puede cancelar y no se puede pagar o
                canjear por un vale si no se utiliza.</li>
              <li>En caso necesario, PerfectFit puede añadirse posteriormente hasta el momento de la entrega del pedido
                Schuette®.</li>
              <li>No se aplican restricciones por país. Todos los países de entrega de Schuette® Manufaktur pueden
                utilizar PerfectFit.</li>
            </ol>
          </div>
        </div>
      </template>
      <template v-if="addonMoreInfo === 'perfect-fit' && currentLang === 'fr' && project === 'schuette'">
        <div class="addon-modal content">
          <h3>Schuette® PerfectFit</h3>

          <p>La marque Schuette® PerfectFit vous permet d'adapter ultérieurement le produit à 360° (dimensions, couleur
            du tissu et type de montage), même jusqu'à 30 jours après la livraison !</p>
          <p>1x correction des dimensions, changement de support ou de couleur inclus, même jusqu'à 30 jours après la
            livraison !</p>
          <p>Avec ce pack « Sérénité et bonheur », vous aurez toujours l'esprit libre et la certitude absolue que votre
            produit Schuette® de qualité vous conviendra à tous égards, à votre style et à votre maison, <b>même si le
              chat du voisin a sauté sur votre clavier pendant la commande !</b></p>

          <p>le paquet de correction complet:</p>
          <ul>
            <li><b>Une protection complète pour toutes les demandes de correction</b>: en plus de l'adaptation des
              mesures, il est possible de corriger la couleur, la collection ou le support. <span
                class="bolded-green">Une protection complète pour toutes les demandes de correction</span></li>
            <li><b>Chaque produit </b>: plissés, stores et rideaux, sans restriction. <span
                class="bolded-green">Uniquement chez Schuette® !</span></li>
            <li><b>Peut être ajouté par produit</b>: ne doit pas être ajouté à l'ensemble de la commande. Prix par
              produit, avec et sans PerfectFit visible.</li>
            <li><b>Il n'y a pas de limite de quantité par commande</b>: PerfectFit peut être ajouté séparément à chaque
              produit.</li>
            <li><b>Pas de prix fixe</b>: plus la dimension du produit est petite, plus son prix est bas.</li>
            <li><b>Jusqu'à 30 jours</b> après la livraison.</li>
            <li><b>Carton de retour quelconque</b>: il n'est pas nécessaire de nous renvoyer le produit dans son carton
              d'origine.</li>
            <li><b>Livraison gratuite après adaptation de notre part chez vous, quelle que soit la dimension du
                produit.</b></li>
          </ul>

          <table>
            <thead>
              <th></th>
              <th>Schuette® PerfectFit</th>
            </thead>
            <tbody>
              <tr>
                <td>Autres dimensions</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Autre couleur et collection de tissus</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Autre support</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Tout type de produit possible</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Délai à partir de la livraison (jours)</td>
                <td><b>30</b></td>
              </tr>
              <tr>
                <td>Livraison gratuite pour chaque mesure</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>En option & à réserver séparément</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Peut être ajouté par produit</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
            </tbody>
          </table>

          <div class="addon-box">
            <p>C'est aussi simple que ça :</p>
            <ul>
              <li><b>Étape 1</b>: Contactez le service client Schuette® et indiquez la nouvelle configuration souhaitée.
                Comme toujours, vous recevrez bien sûr des conseils personnalisés de la part de nos experts Schuette®).
              </li>
              <li><b>Étape 2</b>: Envoyez-nous ensuite votre produit Schuette®.</li>
              <li><b>Étape 3</b>: Nous fabriquons votre produit Schuette® PerfectFit selon vos nouvelles spécifications,
                nous l'emballons et vous le renvoyons avec un baiser d'adieu.</li>
              <li><b>Étape 4</b>: Voilà - votre produit Schuette® PerfectFit, à nouveau fabriqué avec amour, vous
                parvient maintenant parfaitement adapté à tous points de vue.</li>
            </ul>
          </div>

          <div class="conditions">
            <p>Schuette® Perfect Fit Termes et conditions :</p>
            <ol>
              <li>La protection PerfectFit comprend une adaptation unique ou une nouvelle fabrication de votre produit
                Schuette®. Pour chaque produit avec protection PerfectFit, les dimensions, les couleurs et/ou les
                supports peuvent être modifiés une fois, c'est-à-dire que le client peut reconfigurer entièrement son
                produit Schuette® une seule fois dans le cadre de PerfectFit.</li>
              <li>Si le défaut est dû à une défaillance du produit, nous le réparerons bien sûr directement,
                indépendamment de PerfectFit. Les livraisons de remplacement sont fabriquées dans la configuration
                initialement commandée. Dans ce cas, il est possible, si nécessaire, d'utiliser PerfectFit pour faire
                produire la nouvelle configuration du produit dans un autre format.</li>
              <li>Elle n'est pas valable pour le produit pour lequel elle a été réservée.</li>
              <li>Pour pouvoir utiliser la protection PerfectFit, il faut en informer notre service clientèle dans les
                30 jours civils suivant la livraison. La réception de la demande d'activation équivaut à une réponse de
                notre service clientèle. Après une prise de contact réussie avec l'équipe d'assistance, d'autres
                démarches peuvent être entreprises.</li>
              <li>Si les nouvelles dimensions souhaitées sont plus petites que les dimensions commandées initialement,
                le produit initial sera retravaillé dans la mesure du possible. Si cela n'est pas possible, un tout
                nouveau produit sera fabriqué.</li>
              <li>Si le nouveau prix du produit est plus élevé, seule la différence devra être payée. Si la nouvelle
                configuration du produit est moins chère, la différence ne sera pas remboursée. Le prix du produit au
                moment de la commande et le prix du produit au moment de l'activation de PerfectFit sont comparés.</li>
              <li>Les frais de réexpédition sont à la charge du client. Dans le cadre de PerfectFit, nous prenons en
                charge les frais de réexpédition de notre part vers le client.</li>
              <li>L'annulation de produits sur mesure et le remboursement du prix d'achat ne sont pas possibles dans le
                cadre de Schuette® PerfectFit. De même, l'option supplémentaire PerfectFit ne peut pas être annulée. Si
                elle n'est pas utilisée, elle ne peut pas être remboursée ou échangée contre un bon d'achat.</li>
              <li>PerfectFit peut être ajouté ultérieurement si nécessaire jusqu'au moment de la livraison de la
                commande Schuette®.</li>
              <li>Es gibt keine Länderbeschränkungen. Jedes Lieferland der Schuette® Manufaktur kann PerfectFit nutzen.
              </li>
            </ol>
          </div>
        </div>
      </template>
      <template v-if="addonMoreInfo === 'perfect-fit' && currentLang === 'it' && project === 'schuette'">
        <div class="addon-modal content">
          <h3>Schuette® PerfectFit</h3>

          <p>Schuette® PerfectFit consente di apportare successive modifiche al prodotto a 360° (dimensioni, colore del
            tessuto e tipo di montaggio) anche fino a 30 giorni dopo la consegna!</p>
          <p>1 correzione di taglia, supporto o cambio di colore inclusi, anche fino a 30 giorni dopo la consegna!</p>
          <p>Grazie a questo pacchetto di prodotti senza pensieri, avrete sempre la tranquillità e l'assoluta certezza
            che il vostro prodotto di qualità Schuette® sarà adatto a voi, al vostro stile e alla vostra casa sotto ogni
            punto di vista, <b>anche se si scopre che il gatto del vicino è saltato sulla vostra tastiera mentre stavate
              ordinando!</b></p>

          <p>Il pacchetto di correzione completo comprende:</p>
          <ul>
            <li><b>Protezione a tutto tondo per OGNI richiesta di correzione</b>: oltre alla regolazione delle
              dimensioni, sono possibili anche correzioni di colore, di collezione o di staffa. <span
                class="bolded-green">Solo da Schuette®!</span></li>
            <li><b>Ogni prodotto</b>: tende plissettate, tende a rullo e tende, senza restrizioni. <span
                class="bolded-green">Solo da Schuette®!</span></li>
            <li><b>Può essere aggiunto per ogni prodotto</b>: Non deve essere aggiunto all'intero ordine. Prezzo
              indicato per prodotto con e senza PerfectFit.</li>
            <li><b>Nessun limite di quantità per ordine</b>: PerfectFit può essere aggiunto a ciascun prodotto
              separatamente.</li>
            <li><b>Nessun prezzo fisso</b>: più piccole sono le dimensioni del prodotto, più basso è il prezzo.</li>
            <li><b>Anche fino a 30 giorni</b> dopo la consegna.</li>
            <li><b>Qualsiasi scatola per la restituzione</b>: la restituzione da parte vostra a noi non deve essere
              necessariamente nella scatola originale.</li>
            <li><b>Spedizione gratuita</b>: dopo la personalizzazione da parte nostra, indipendentemente dalle
              dimensioni del prodotto.</li>
          </ul>

          <table>
            <thead>
              <th></th>
              <th>Schuette® PerfectFit</th>
            </thead>
            <tbody>
              <tr>
                <td>Altre dimensioni</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Altro colore e collezione di tessuto</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Altra staffa</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Qualsiasi tipo di prodotto possibile</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Tempo di consegna (giorni)</td>
                <td><b>30</b></td>
              </tr>
              <tr>
                <td>Spedizione gratuita per ogni ordine</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Opzionale e prenotabile separatamente</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Può essere prenotato per prodotto</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
            </tbody>
          </table>

          <div class="addon-box">
            <p>È così semplice:</p>
            <ul>
              <li><b>Passo 1</b>: Contattare il servizio clienti Schuette® e indicare la nuova configurazione
                desiderata. (Come sempre, riceverete una consulenza personalizzata dai nostri esperti Schuette®).</li>
              <li><b>Passo 2</b>: Allora inviateci il vostro prodotto Schuette®.</li>
              <li><b>Passo 3</b>: Produciamo il vostro prodotto Schuette® PerfectFit secondo le vostre nuove specifiche,
                lo imballiamo e ve lo rispediamo con un bacio d'addio.</li>
              <li><b>Passo 4</b>: Voilà - il vostro prodotto Schuette® PerfectFit, ancora una volta realizzato con
                amore, arriva ora perfettamente aderente sotto ogni aspetto.</li>
            </ul>
          </div>

          <div class="conditions">
            <p>Termini e condizioni di Schuette® Perfect Fit:</p>
            <ol>
              <li>PerfectFit prevede la personalizzazione una tantum o la nuova produzione del prodotto Schuette®. Le
                dimensioni, i colori e/o i supporti del prodotto possono essere modificati una sola volta per ogni
                prodotto con la protezione PerfectFit, ossia il cliente può riconfigurare completamente il suo prodotto
                Schuette® una sola volta nell'ambito di PerfectFit.</li>
              <li>Se viene richiesta la sostituzione di un prodotto perché il guasto è imputabile a noi, naturalmente
                provvederemo a correggerlo direttamente, indipendentemente da PerfectFit, e le consegne sostitutive
                saranno prodotte nella configurazione originariamente ordinata. Se necessario, PerfectFit può essere
                utilizzato per far produrre il nuovo prodotto in una configurazione diversa.</li>
              <li>PerfectFit si applica al prodotto per il quale è stato prenotato.</li>
              <li>Per poter usufruire della protezione PerfectFit prenotata, il nostro servizio clienti deve essere
                informato entro 30 giorni di calendario dalla consegna. La ricezione della richiesta di attivazione
                equivale a una risposta da parte del nostro servizio clienti. Dopo aver contattato con successo il team
                di assistenza, è possibile avviare le fasi successive.</li>
              <li>Se le nuove dimensioni richieste sono inferiori a quelle ordinate all'inizio, il prodotto originale
                verrà rielaborato per quanto possibile. Se ciò non fosse possibile, verrà realizzato un prodotto
                completamente nuovo.</li>
              <li>Se la nuova configurazione del prodotto è più costosa, dovrete pagare solo la differenza. Se la nuova
                configurazione del prodotto è più economica, la differenza non verrà rimborsata. Vengono confrontati il
                prezzo del prodotto al momento dell'ordine e il prezzo del prodotto al momento dell'attivazione di
                PerfectFit.</li>
              <li>I costi della spedizione di ritorno sono a carico del cliente. Come parte di PerfectFit, copriremo i
                costi di spedizione da noi al cliente.</li>
              <li>Non è possibile annullare i prodotti personalizzati e ricevere un rimborso nell'ambito di Schuette®
                PerfectFit. Anche l'opzione aggiuntiva PerfectFit non può essere annullata e non può essere pagata o
                riscattata con un buono se non viene utilizzata.</li>
              <li>Se necessario, PerfectFit può essere aggiunto all'ordine di Schuette® fino al momento della consegna.
              </li>
              <li>Non ci sono restrizioni per i paesi. Ogni paese di consegna di Schuette® Manufaktur può utilizzare
                PerfectFit.</li>
            </ol>
          </div>
        </div>
      </template>
      <template v-if="addonMoreInfo === 'perfect-fit' && currentLang === 'nl' && project === 'schuette'">
        <div class="addon-modal content">
          <h3>Schuette® PerfectFit</h3>

          <p>Schuette® PerfectFit maakt het mogelijk om achteraf 360° productaanpassingen (afmetingen, stofkleur &
            montagetype) door te voeren, zelfs tot 30 dagen na levering!</p>
          <p>1x maatcorrectie, houder of kleurverandering inbegrepen, zelfs tot 30 dagen na levering!</p>
          <p>Met dit zorgeloze pakket heb je altijd gemoedsrust en de absolute zekerheid dat je Schuette®
            kwaliteitsproduct in alle opzichten bij jou, <b>je stijl en je huis past, zelfs als blijkt dat de kat van de
              buren op je toetsenbord sprong terwijl je bestelde!</b></p>

          <p>Het allround correctiepakket omvat:</p>
          <ul>
            <li><b>All-round bescherming voor ELK correctieverzoek</b>: Naast maataanpassingen zijn ook kleur-,
              collectie- of houdercorrecties mogelijk. <span class="bolded-green">Alleen van Schuette®!</span></li>
            <li><b>Elk product</b>: plisségordijnen, rolgordijnen en gordijnen, zonder beperkingen. <span
                class="bolded-green">Alleen van Schuette®!</span></li>
            <li><b>Kan per product worden toegevoegd</b>: Hoeft niet aan de hele bestelling te worden toegevoegd. Prijs
              weergegeven per product met & zonder PerfectFit.</li>
            <li><b>Geen hoeveelheidsbeperking per bestelling</b>: PerfectFit kan aan elk product afzonderlijk worden
              toegevoegd.</li>
            <li><b>Geen vaste prijs</b>: Hoe kleiner het product, hoe lager de prijs.</li>
            <li><b>Zelfs tot 30 dagen</b> na levering.</li>
            <li><b>Elke retourdoos</b>: De retourzending van jou naar ons hoeft niet in de originele doos te zitten.
            </li>
            <li><b>Gratis verzending</b> na maatwerk van ons naar jou, ongeacht de afmetingen van het product.</li>
          </ul>

          <table>
            <thead>
              <th></th>
              <th>Schuette® PerfectFit</th>
            </thead>
            <tbody>
              <tr>
                <td>Andere afmetingen</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Andere stofkleur en collectie</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Andere beugel</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Elk producttype mogelijk</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Tijd vanaf levering (dagen)</td>
                <td><b>30</b></td>
              </tr>
              <tr>
                <td>Gratis verzending bij elke bestelling</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Optioneel & kan apart geboekt worden</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Per product te boeken</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
            </tbody>
          </table>

          <div class="addon-box">
            <p>Zo eenvoudig is het:</p>
            <ul>
              <li><b>Stap 1</b>: Neem contact op met de Schuette® klantenservice en vermeld je nieuwe gewenste
                configuratie. (Zoals altijd krijg je natuurlijk persoonlijk advies van onze Schuette® experts).</li>
              <li><b>Stap 2</b>: Stuur ons dan je Schuette® product.</li>
              <li><b>Stap 3</b>: Wij produceren uw Schuette® PerfectFit product volgens uw nieuwe specificaties,
                verpakken het en sturen het naar u terug met een afscheidskus.</li>
              <li><b>Stap 4</b>: Voilà - uw Schuette® PerfectFit product, opnieuw met liefde gemaakt, komt nu in elk
                opzicht perfect passend aan.</li>
            </ul>
          </div>

          <div class="conditions">
            <p>Schuette® Perfect Fit algemene voorwaarden:</p>
            <ol>
              <li>PerfectFit omvat een eenmalige aanpassing of nieuwe productie van uw Schuette® product. De
                productafmetingen, kleuren en/of houders kunnen eenmalig per product met PerfectFit bescherming worden
                gewijzigd, d.w.z. de klant kan zijn Schuette® product in het kader van PerfectFit eenmalig volledig
                opnieuw configureren.</li>
              <li>Als een vervangend product wordt aangevraagd omdat de fout bij ons ligt, verhelpen wij dit uiteraard
                direct onafhankelijk van PerfectFit, waarbij vervangende leveringen in de oorspronkelijk bestelde
                configuratie worden geproduceerd. Desgewenst kan PerfectFit worden ingeschakeld om het nieuwe product in
                een andere productconfiguratie te laten vervaardigen.</li>
              <li>PerfectFit is van toepassing op het product waarvoor het geboekt is.</li>
              <li>Om gebruik te kunnen maken van de geboekte PerfectFit bescherming, moet onze klantenservice binnen 30
                kalenderdagen na levering hiervan op de hoogte worden gesteld. Ontvangst van het activeringsverzoek
                staat gelijk aan een reactie van onze klantenservice. Na succesvol contact met de klantenservice kunnen
                verdere stappen in gang worden gezet.</li>
              <li>Als de nieuwe gevraagde afmetingen kleiner zijn dan de afmetingen die in het begin werden besteld,
                wordt het oorspronkelijke product zo veel mogelijk bewerkt. Als dit niet mogelijk is, wordt een volledig
                nieuw product gemaakt.</li>
              <li>Als de nieuwe productconfiguratie duurder is, hoef je alleen het verschil te betalen. Als de nieuwe
                productconfiguratie goedkoper is, wordt het verschil niet terugbetaald. De productprijs op het moment
                van bestellen en de productprijs op het moment van activeren van PerfectFit worden met elkaar
                vergeleken.</li>
              <li>De kosten voor de retourzending zijn voor rekening van de klant. In het kader van PerfectFit nemen wij
                de kosten voor de retourzending van ons naar de klant voor onze rekening.</li>
              <li>Het is niet mogelijk om aangepaste producten te annuleren en een terugbetaling te ontvangen onder
                Schuette® PerfectFit. De extra PerfectFit optie kan ook niet worden geannuleerd en kan niet worden
                uitbetaald of ingewisseld voor een tegoedbon als er geen gebruik van wordt gemaakt.</li>
              <li>PerfectFit kan indien gewenst tot het moment van levering aan de Schuette® bestelling worden
                toegevoegd.</li>
              <li>Er zijn geen landbeperkingen. Elk leveringsland van Schuette® Manufaktur kan PerfectFit gebruiken.
              </li>
            </ol>
          </div>
        </div>
      </template>
      <template v-if="addonMoreInfo === 'perfect-fit' && currentLang === 'no' && project === 'schuette'">
        <div class="addon-modal content">
          <h3>Schuette® PerfectFit</h3>

          <p>Schuette® PerfectFit gir deg mulighet til å gjøre etterfølgende 360° produktjusteringer (dimensjoner,
            stofffarge og monteringstype) selv opptil 30 dager etter levering!</p>
          <p>1x størrelseskorreksjon, holder eller fargeendring inkludert, selv opptil 30 dager etter levering!</p>
          <p>Med denne bekymringsfrie pakken har du alltid ro i sjelen og den absolutte vissheten om at ditt
            Schuette®-kvalitetsprodukt vil passe deg, din stil og ditt hjem i alle henseender, <b>selv om det skulle
              vise seg at naboens katt hoppet på tastaturet ditt mens du bestilte det!</b></p>

          <p>Den allsidige korreksjonspakken inkluderer:</p>
          <ul>
            <li><b>Allsidig beskyttelse for ALLE korreksjonsønsker</b>: I tillegg til dimensjonsjusteringer er det også
              mulig å korrigere farge, kolleksjon eller brakett. <span class="bolded-green">Bare fra Schuette®!</span>
            </li>
            <li><b>Alle produkter</b>: plisségardiner, rullegardiner og gardiner, uten begrensninger. <span
                class="bolded-green">Bare fra Schuette®!</span></li>
            <li><b>Kan legges til per produkt</b>: Må ikke legges til hele bestillingen. Prisen vises per produkt med og
              uten PerfectFit.</li>
            <li><b>Ingen antallsbegrensning per bestilling</b>: PerfectFit kan legges til hvert produkt separat.</li>
            <li><b>Ingen fast pris</b>: Jo mindre produktstørrelsen er, desto lavere er prisen.</li>
            <li><b>Til og med opptil 30 dager</b> etter levering.</li>
            <li><b>Eventuell retureske</b>: Returen fra deg til oss trenger ikke å være i originalesken.</li>
            <li><b>Gratis frakt</b> etter tilpasning fra oss til deg, uavhengig av produktets dimensjoner.</li>
          </ul>

          <table>
            <thead>
              <th></th>
              <th>Schuette® PerfectFit</th>
            </thead>
            <tbody>
              <tr>
                <td>Andre dimensjoner</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Annen stofffarge og kolleksjon</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Annen brakett</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Alle produkttyper er mulige</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Tid fra levering (dager)</td>
                <td><b>30</b></td>
              </tr>
              <tr>
                <td>Gratis frakt med alle bestillinger</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Valgfritt og kan bestilles separat</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Kan bestilles per produkt</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
            </tbody>
          </table>

          <div class="addon-box">
            <p>Så enkelt er det:</p>
            <ul>
              <li><b>Trinn 1</b>: Kontakt Schuette® kundeservice og oppgi din nye ønskede konfigurasjon. (Som alltid vil
                du selvfølgelig få personlig rådgivning fra våre Schuette®-eksperter).</li>
              <li><b>Trinn 2</b>: Send oss ditt Schuette®-produkt.</li>
              <li><b>Trinn 3</b>: Vi produserer Schuette® PerfectFit-produktet ditt i henhold til dine nye
                spesifikasjoner, pakker det og sender det tilbake til deg med et farvelkyss.</li>
              <li><b>Trinn 4</b>: Voilà - Schuette® PerfectFit-produktet ditt, som nok en gang er laget med kjærlighet,
                kommer nå perfekt tilpasset i alle henseender.</li>
            </ul>
          </div>

          <div class="conditions">
            <p>Schuette® Perfect Fit vilkår og betingelser:</p>
            <ol>
              <li>PerfectFit omfatter en engangstilpasning eller ny produksjon av Schuette®-produktet ditt.
                Produktdimensjoner, farger og/eller holdere kan endres én gang per produkt med PerfectFit-beskyttelse,
                dvs. at kunden kan omkonfigurere Schuette®-produktet sitt fullstendig én gang som en del av PerfectFit.
              </li>
              <li>Hvis det blir bedt om en produktutskiftning fordi feilen ligger hos oss, vil vi selvfølgelig utbedre
                den direkte uavhengig av PerfectFit, og erstatningsleveransene vil bli produsert i den konfigurasjonen
                som opprinnelig ble bestilt. Om nødvendig kan PerfectFit brukes til å få det nye produktet produsert i
                en annen produktkonfigurasjon.</li>
              <li>PerfectFit gjelder for det produktet det ble bestilt for.</li>
              <li>For å kunne benytte seg av PerfectFit-beskyttelsen som er bestilt, må vår kundeservice informeres om
                dette innen 30 kalenderdager etter levering. Mottak av aktiveringsforespørselen er det samme som et svar
                fra vårt kundeserviceteam. Etter at du har kontaktet kundeserviceteamet, kan ytterligere trinn
                iverksettes.</li>
              <li>Hvis de nye ønskede dimensjonene er mindre enn de dimensjonene som ble bestilt i utgangspunktet, vil
                det opprinnelige produktet bli omarbeidet så langt det er mulig. Hvis dette ikke er mulig, vil et helt
                nytt produkt bli laget.</li>
              <li>Hvis den nye produktkonfigurasjonen er dyrere, trenger du bare å betale differansen. Hvis den nye
                produktkonfigurasjonen er billigere, vil differansen ikke bli refundert. Produktprisen på
                bestillingstidspunktet og produktprisen på tidspunktet for aktivering av PerfectFit sammenlignes.</li>
              <li>Kostnadene for returforsendelsen skal bæres av kunden. Som en del av PerfectFit vil vi bære kostnadene
                for returforsendelse fra oss til kunden.</li>
              <li>Det er ikke mulig å avbestille tilpassede produkter og få refusjon under Schuette® PerfectFit. Det
                ekstra PerfectFit-alternativet kan heller ikke kanselleres og kan ikke utbetales eller innløses mot en
                kupong hvis det ikke brukes.</li>
              <li>PerfectFit kan legges til Schuette®-bestillingen frem til leveringstidspunktet ved behov.</li>
              <li>Det finnes ingen landbegrensninger. Alle Schuette® Manufaktur-leveringsland kan bruke PerfectFit.</li>
            </ol>
          </div>
        </div>
      </template>
      <template v-if="addonMoreInfo === 'perfect-fit' && project === 'rzaska'">
        <div class="addon-modal content">
          <h3>Rząska® PerfectFit</h3>

          <p>Rząska® PerfectFit daje Ci możliwość dokonania późniejszych, 360° zmian produktu (wymiary, kolor tkaniny i
            rodzaj montażu) nawet do 30 dni po dostawie!</p>
          <p>1x korekta rozmiaru, uchwytu, lub zmiana koloru wliczone, nawet do 30 dni po dostawie!</p>
          <p>Z tym beztroskim pakietem masz zawsze absolutną pewność, że Twój produkt marki Rząska® będzie pasował
            do Ciebie, Twojego stylu i Twojego domu w każdym aspekcie, <b>nawet jeśli okaże się, że kot sąsiadów
              wskoczył na Twoją klawiaturę podczas składania zamówienia!</b></p>

          <p>Wszechstronny pakiet korekcyjny obejmuje:</p>
          <ul>
            <li><b>Pełna swoboda edycji</b>: Oprócz zmiany wymiarów
              możliwe są również korekty koloru, kolekcji lub uchwytu. <span class="bolded-green">Tylko u
                Rząska®!</span></li>
            <li><b>Wszystkie produkty</b>: plisy, rolety i firany, bez ograniczeń. <span class="bolded-green">Tylko u
                Rząska®!</span></li>
            <li><b>Możlowość dodania do każdego produktu osobno.</b> Nie trzeba dodawać do całego zamówienia. Cena wyświetlana jest
              dla każdego produktu z i bez PerfectFit.</li>
            <li><b>Bez ograniczeń ilościowych na zamówienie</b>: PerfectFit może być dodane do każdego produktu osobno.
            </li>
            <li><b>Elastyczne ceny</b>: Im mniejszy produkt, tym niższa cena.</li>
            <li><b>Nawet do 30 dni</b> po dostawie.</li>
            <li><b>Dowolne pudełko zwrotne</b>: Zwrot do nas nie musi być w oryginalnym opakowaniu.</li>
            <li><b>Darmowa wysyłka</b> od nas do Ciebie, niezależnie od wymiarów produktu.</li>
          </ul>

          <table>
            <thead>
              <th></th>
              <th>Rząska® PerfectFit</th>
            </thead>
            <tbody>
              <tr>
                <td>Inne wymiary</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Inny kolor tkaniny i kolekcja</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Inny uchwyt</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Każdy typ produktu jest możliwy</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Czas od dostawy zamówienia (dni)</td>
                <td><b>30</b></td>
              </tr>
              <tr>
                <td>Darmowa wysyłka do Ciebie</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Opcjonalne i dostępne na życzenie</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
              <tr>
                <td>Dla części lub całego koszyka</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
            </tbody>
          </table>

          <div class="addon-box">
            <p>Tak to działa:</p>
            <ul>
              <li><b>Krok 1</b>: Skontaktuj się z obsługą klienta Rząska® i podaj swoją nową, pożądaną konfigurację. (Jak
                zawsze, otrzymasz oczywiście indywidualną poradę od naszych ekspertów Rząska®).</li>
              <li><b>Krok 2</b>: Wyślij nam swój produkt marki Rząska®.</li>
              <li><b>Krok 3</b>: Wyprodukujemy Twój produkt PerfectFit marki Rząska® zgodnie z nowymi specyfikacjami,
                zapakujemy go i wyślemy do Ciebie z buziakiem na pożegnanie.</li>
              <li><b>Krok 4</b>: Voilà - Twój ponownie z miłością wykonany produkt PerfectFit marki Rząska® teraz będzie
                idealnie dopasowany w każdym aspekcie.</li>
            </ul>
          </div>

          <div class="conditions">
            <p>Warunki i zasady Rząska® PerfectFit:</p>
            <ol>
              <li>PerfectFit obejmuje jednorazową zmianę lub nową produkcję Twojego produktu Rząska®. Wymiary produktów,
                kolory i/lub uchwyty mogą być jednokrotnie zmienione na każdym produkcie z ochroną PerfectFit, tj.
                klient może całkowicie zmienić swój produkt Rząska® raz w ramach PerfectFit.</li>
              <li>Jeśli zostanie zażądana wymiana produktu z powodu naszej winy, oczywiście naprawimy to natychmiast
                niezależnie od PerfectFit, a zamienniki będą produkowane w konfiguracji, która została pierwotnie
                zamówiona. Jeśli to konieczne, to na tym etapie PerfectFit może być użyte do wytworzenia nowego produktu w innej
                konfiguracji produktu.</li>
              <li>PerfectFit ma zastosowanie do produktu, dla którego zostało zamówione.</li>
              <li>Aby skorzystać z ochrony PerfectFit, należy powiadomić naszą obsługę klienta w ciągu 30 dni
                kalendarzowych od dostawy. Otrzymanie prośby o aktywację jest równoznaczne z odpowiedzią naszego zespołu
                obsługi klienta. Po pomyślnym kontakcie z obsługą klienta, można podjąć dalsze kroki.</li>
              <li>Jeśli nowe, żądane wymiary są mniejsze niż wymiary pierwotnie zamówione, pierwotny produkt zostanie
                zmodyfikowany, o ile to możliwe. Jeśli nie jest to możliwe, zostanie wyprodukowany całkowicie nowy
                produkt.</li>
              <li>Jeśli nowa konfiguracja produktu jest droższa, należy zapłacić tylko różnicę. Jeśli nowa konfiguracja
                produktu jest tańsza, różnica nie zostanie zwrócona. Porównywana jest cena produktu w momencie
                zamówienia i cena produktu w momencie aktywacji PerfectFit.</li>
              <li>Dostawę zwrotną ponosi klient. W ramach PerfectFit my pokrywamy dostawę produktu od nas do klienta.
              </li>
              <li>W ramach Rząska® PerfectFit nie ma możliwości anulowania dostosowanych produktów i otrzymania zwrotu pieniędzy. PerfectFit również nie może być anulowana i nie może być wypłacona ani
                wymieniona na bon, jeśli nie zostanie użyta.</li>
              <li>PerfectFit może zostać dodane do zamówienia Rząska® do momentu dostawy, jeśli jest to konieczne.</li>
              <li>Nie ma ograniczeń krajowych. Wszystkie kraje dostaw dostępne w manufakturze Rząska® mogą korzystać z PerfectFit.
              </li>
            </ol>
          </div>
        </div>
      </template>


      <template v-if="addonMoreInfo && addonMoreInfo.includes('years')">
        <div class="addon-modal content">
          <h3>{{ $t('perfectFit.proGuardModalTitle') }}</h3>
          <p v-html="$t('perfectFit.proGuardModalText1')" />
          <ul>
            <li v-for="(proGuardIncident, proGuardIncidentIndex) in $t('perfectFit.proGuardIncident')"
              :key="proGuardIncidentIndex" v-html="proGuardIncident" />
          </ul>
          <p v-html="$t('perfectFit.proGuardModalText2')" />
          <ul>
            <li v-for="(proGuardList, proGuardListIndex) in $t('perfectFit.proGuardList')" :key="proGuardListIndex"
              v-html="proGuardList" />
          </ul>
          <table>
            <thead>
              <th />
              <th>{{ $t('perfectFit.proGuardTableTitle') }}</th>
            </thead>
            <tbody>
              <tr v-for="(proGuardTableRow, proGuardTableRowIndex) in $t('perfectFit.proGuardTableRow')"
                :key="proGuardTableRowIndex">
                <td>{{ proGuardTableRow }}</td>
                <td><b-icon icon="checkmark-solid" /></td>
              </tr>
            </tbody>
          </table>
          <div class="addon-box">
            <p>{{ $t('perfectFit.proGuardHowTo') }}</p>
            <ul>
              <li v-for="(proGuardStep, proGuardStepIndex) in $t('perfectFit.proGuardStep')" :key="proGuardStepIndex"
                v-html="proGuardStep" />
            </ul>
          </div>
          <div class="conditions">
            <p>{{ $t('perfectFit.proGuardConditions') }}</p>
            <ol>
              <li>{{ $t('perfectFit.proGuardCondition1') }}</li>
              <li v-for="(proGuardCondition, proGuardConditionIndex) in $t('perfectFit.proGuardCondition')"
                :key="proGuardConditionIndex">
                {{ proGuardCondition }}
              </li>
            </ol>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ProductAddon from './ProductAddon'

export default {
  components: {
    ProductAddon
  },
  props: {
    data: {
      type: Array,
      default: null
    },
    additionalOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      model: [],
      modal: false,
      addons: [],
      proGuard: [],
      proGuardSelected: false,
      addonMoreInfo: null
    }
  },
  watch: {
    data: {
      handler(value) {
        if (value && Array.isArray(value)) {
          this.proGuard = []
          this.addons = []
          value.forEach((option, index) => {
            if (option.images.find((icon) => { return icon.includes('years') })) {
              this.proGuard.push({
                ...option,
                proGuard: true
              })
            } else {
              this.addons.push({
                ...option,
                proGuard: false
              })
            }
            // console.log(option.images.find((icon) => { return icon.includes('years') }))
            // return option.images.find((icon) => { return icon.includes('years') })
          })
        }
      },
      deep: true,
      immediate: true
    },
    additionalOptions: {
      handler(val) {
        this.proGuardSelected = val.some((item) => {
          return this.proGuard.find(proItem => proItem.id === item.id)
        })
        if (JSON.stringify(this.model) !== JSON.stringify(val)) {
          this.model = val
        }
      },
      deep: true,
      immediate: true
    },
    model: {
      handler() {
        this.$emit('update:additionalOptions', this.model)
      },
      deep: true
    }
  },
  methods: {
    openModal(option) {
      this.addonMoreInfo = option.images.length ? option.images[0] : null
      this.modal = true
    },
    closeModal() {
      this.addonMoreInfo = null
    },
    isAddonSelected(option) {
      return this.additionalOptions.some((item) => {
        return item.id === option.id
      })
    }
  }
}
</script>
